<template>
  <div class="fzf">
    <div class="fzfbox">
      <strong>{{title}}</strong>
      <div v-html="text"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'footerNav',
  data() {
    return {}
  },
  props: {
    title: '',
    text: ''
  },
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fzf {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.notfind {
  height: 450px;
}


.pay {
  height: auto;
  margin-top: 30%;
}

.fzfbox {
  width: 100%;
  padding-top: 110px;
  text-align: center;
  background: url(../../static/images/correct.svg) center 0 no-repeat;
  font-size: 18px;
  line-height: 2;
}

</style>



// WEBPACK FOOTER //
// src/components/paysuccess.vue